import { QuestionType } from "@pulse/api/surveyApi";
import type { TFunction } from "i18next";
import { PULSE_FIELD_LIMITS } from "@pulse/features/pulseFieldLimits";

type QuestionFormValue = {
    questionText: string;
    questionType: QuestionType;
    questionOptions?: string[] | null;
};

export function validateQuestionFields(value: QuestionFormValue, t: TFunction) {
    const hasOptions =
        value.questionType === QuestionType.MULTIPLE_CHOICE ||
        value.questionType === QuestionType.MULTI_SELECT;

    const questionOptionsError = hasOptions
        ? !Array.isArray(value.questionOptions) || value.questionOptions.length < 2
            ? t("question.multipleChoice.validation.atLeastTwoRequired")
            : value.questionOptions.filter((option) => option.trim() !== "").length < 2
              ? t("question.multipleChoice.validation.atLeastTwoFilled")
              : undefined
        : undefined;

    return {
        fields: {
            questionText:
                value.questionText.trim() === ""
                    ? t("question.required")
                    : value.questionText.length > PULSE_FIELD_LIMITS.question.text
                      ? t("question.validation.maxLength", {
                            max: PULSE_FIELD_LIMITS.question.text,
                        })
                      : undefined,
            questionOptions: questionOptionsError,
        },
    };
}
